module.exports = __webpack_public_path__ + "static/media/hydra-logo-white.d40852f8.png";